import { Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClienteComboOutput, PedidoConsultaOutput } from 'src/app/@shared/models/consulta-detalhe';
import { ConsultaDetalhesPorContaInput } from 'src/app/@shared/models/consulta-detalhes/consulta-detalhes.model';
import { StorageService } from 'src/app/services/storage/storage.service';

@Component({
  selector: 'app-detalhe-formulario-idconta-interna',
  templateUrl: './detalhe-formulario-idconta-interna.component.html',
  styleUrls: ['./detalhe-formulario-idconta-interna.component.scss']
})
export class DetalheFormularioIdcontaInternaComponent implements OnInit {
  public external = StorageService.getExternalAccess();
  usuario = StorageService.getPerfilUsuario();
  @Input('clientes') clientes:any[];

  public clientesFiltrados: ReplaySubject<ClienteComboOutput[]> = new ReplaySubject<ClienteComboOutput[]>(1);
  private onDestroy = new Subject<void>();
  public clienteMultiFilter: FormControl = new FormControl();

  formConsultaIdConta = new FormGroup({
    idConta: new FormControl('', {
      validators: [
        Validators.maxLength(50),
        Validators.pattern('^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ ]+$'),
        Validators.required
      ],
      updateOn: 'change'
    }),
    cliente: new FormControl('', Validators.required)
  });

  constructor() { }

  ngOnInit() {
    this.clienteMultiFilter.valueChanges
        .pipe(takeUntil(this.onDestroy))
        .subscribe(() => {
          this.filtroGeral(this.clientes, this.clienteMultiFilter, this.clientesFiltrados, 'nome');
        });
  }

  private filtroGeral(filtro: any, multifilter: any, filtered: any, field: string) {
    if (!filtro) {
      return;
    }
    let search = multifilter.value;
    if (!search) {
      filtered.next(filtro.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    filtered.next(
      filtro.filter(response => response[field].toLowerCase().indexOf(search) > -1)
    );
  }

  public onInput: EventEmitter<ConsultaDetalhesPorContaInput> = new EventEmitter();
  search()
  {

    this.onInput.emit({
      idConta:  this.formConsultaIdConta.get("idConta").value,
      clienteId : Number(this.formConsultaIdConta.get("cliente").value)
    });
  }

}
